import React from 'react';
import {View, StyleSheet, TouchableOpacity, Platform, Dimensions} from 'react-native';
import {responsiveHeight, responsiveWidth} from './customResponsiveDimension';
import {M2I, HOW_IT_WORKS, LIST_OF_HOLIDAYS, HELP, FAQ, CONTACT_US, LEGAL, DISCLAIMER, PRIVACY_POLICY, GOOGLE_PLAY, APP_STORE, FOLLOW_US, TERMS_AND_CONDITIONS, ICICI_BANK, TRAVEL_A_LOT, GET_THE_APP, TRANSFER_M2I, SEND_M2I_INDIA, SEND_M2I_SING, SEND_M2I_UAE, QUERIES_AND_COMPLAINTS} from '../constants/displayConstants';
import {RESCOUNTRYID, getPrefData, storePrefData, FIREFOX_INFO} from '../storage/preferenceStorage';
import {COUNTRY_CANADA, COUNTRY_UAE, COUNTRY_UK, COUNTRY_USA} from '../utils/countryCode';
import {hocComponent} from '.';
import CustomText from './customText';
import packageJson from '../../package.json';
import {HOME_PAGE} from '../utils/domainUrl';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {NRI_BANKING, APPLE_STORE, GOOGLE_PLAY_STORE, ICICIBANK_USA, US_HOLIDAY_LINK, NON_US_DISCLAIMER_LINK, US_TERMS_AND_CONDTION_LINK, NON_US_HOLIDAY_LINK, NON_US_TERMS_AND_CONDTION_LINK, FACEBOOK_ICICI, DISCLAIMER_ICCI, PRIVACY_POLICY_ICCI, FAQ_ICCI} from '../utils/externalUrl';


global.appVersion = packageJson.version;

const styles = StyleSheet.create({
  containerStyle: {
    marginHorizontal: responsiveWidth(3),
    marginTop: responsiveHeight(8),
    marginBottom: responsiveHeight(3)
  },
  textStyle: {
    lineHeight: 48,
    color: 'white'
  },
  textStyleWithOpacity: {
    lineHeight: 35,
    color: 'rgba(255,255,255,0.5)'
  },

  disabledText: {
    color: '#dcdcdc'
  },
  group: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  buttonTextStyle: {
    color: '#fff',
    marginLeft: responsiveWidth(0.3),
    fontSize: 16
  },
  buttonStyle: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderRadius: 5,
    padding: 10
  },
  buttonOuterView: {
    flex: 1.5,
    display: 'flex',
    marginVertical: responsiveHeight(1)
  },
  // subContainerStyle: {
  //   // flex: 1,
  //   flexDirection: 'column',
  // },
  subContainerStyle_XXXHDPI: {flexDirection: 'row'},
  subContainerStyle_XXHDPI: {flexDirection: 'row'},
  subContainerStyle_XHDPI: {flexDirection: 'column'},
  subContainerStyle_MDPI: {flexDirection: 'column'},
  subContainerStyle_HDPI: {flexDirection: 'column'},
  subContainerStyle_LDPI: {flexDirection: 'column'},
  subContainerStyle_LAPTOP: {flexDirection: 'row'},
  subBottomContainer: {
    borderTopWidth: 1,
    borderColor: 'rgba(255,255,255,0.5)',
    marginHorizontal: responsiveWidth(8),
    display: 'none'
  },
  subBottomContainer_XXHDPI: {display: 'flex'},
  subBottomContainer_XHDPI: {display: 'flex'},
  subBottomContainer_MDPI: {display: 'flex'},
  subBottomContainer_HDPI: {display: 'flex'},
  subBottomContainer_LDPI: {display: 'flex'},
  subBottomContainer_LAPTOP: {display: 'none'},

  buttonOuterView_XXXHDPI: {
    display: 'flex'
  },
  buttonOuterView_XXHDPI: {display: 'none'},
  buttonOuterView_XHDPI: {display: 'none'},
  buttonOuterView_MDPI: {display: 'none'},
  buttonOuterView_HDPI: {display: 'none'},
  buttonOuterView_LDPI: {display: 'none'},
  buttonOuterView_LAPTOP: {display: 'flex'},
  containerStyle_LAPTOP: {
    marginBottom: responsiveHeight(8)
  },
  textStyle1: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    marginRight: responsiveWidth(3)
  },
  ICICIBankTextStyle: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    marginRight: responsiveWidth(3),
    display: 'flex'
  },
  ICICIBankTextStyle1: {
    justifyContent: 'center',
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    marginRight: responsiveWidth(3),
    textAlign: 'center',
    marginTop: responsiveHeight(2)
  },

  buttonTextStyle1: {
    color: 'rgba(255,255,255,0.5)',
    marginLeft: responsiveWidth(1),
    display: 'flex',
    fontSize: 12
  },
  outerContainerStyle1: {
    flexDirection: 'row',
    flex: 1,
    marginHorizontal: responsiveWidth(2)
  },
  outerTextStyle1: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  faceBookContainerBtnStyle: {
    //  flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: responsiveWidth(2),
    marginRight: responsiveWidth(2)
  },
  playStoreContainerBtnStyle: {
    // flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: responsiveWidth(2),
    marginHorizontal: 0
  },
  appStoreBtnContainerStyle: {
    //   flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: responsiveWidth(2),
    marginHorizontal: 0
  },
  buttonOuterStyle1: {
    flexDirection: 'row',
    marginTop: 0,

    justifyContent: 'center'
  },
  buttonOuterStyle1_LAPTOP: {marginTop: 0},
  buttonOuterStyle1_XXXHDPI: {marginTop: 0},
  buttonOuterStyle1_XXHDPI: {marginTop: 0},
  buttonOuterStyle1_XHDPI: {
    marginTop: responsiveHeight(3),
    marginHorizontal: responsiveWidth(3)
  },
  buttonOuterStyle1_HDPI: {
    marginTop: responsiveHeight(3),
    marginHorizontal: responsiveWidth(3)
  },
  buttonOuterStyle1_MDPI: {
    marginTop: responsiveHeight(3),
    marginHorizontal: responsiveWidth(3)
  },
  buttonOuterStyle1_LDPI: {
    marginTop: responsiveHeight(3),
    marginHorizontal: responsiveWidth(3)
  },
  outerContainerStyle1_LAPTOP: {flexDirection: 'row'},
  outerContainerStyle1_XXXHDPI: {flexDirection: 'row'},
  outerContainerStyle1_XXHDPI: {flexDirection: 'row'},
  outerContainerStyle1_XHDPI: {flexDirection: 'column'},
  outerContainerStyle1_HDPI: {flexDirection: 'column'},
  outerContainerStyle1_MDPI: {flexDirection: 'column'},
  outerContainerStyle1_LDPI: {flexDirection: 'column'},

  buttonTextStyle1_XXHDPI: {display: 'none'},
  buttonTextStyle1_XHDPI: {display: 'none'},
  buttonTextStyle1_HDPI: {display: 'none'},
  buttonTextStyle1_MDPI: {display: 'none'},
  buttonTextStyle1_LDPI: {display: 'none'},
  buttonTextStyle1_XXXHDPI: {display: 'flex'},
  buttonTextStyle1_LAPTOP: {display: 'flex'},

  outerTextStyle1_LAPTOP: {justifyContent: 'flex-start'},
  outerTextStyle1_XXXHDPI: {justifyContent: 'flex-start'},
  outerTextStyle1_XXHDPI: {justifyContent: 'flex-start'},
  outerTextStyle1_XHDPI: {justifyContent: 'center'},
  outerTextStyle1_HDPI: {justifyContent: 'center'},
  outerTextStyle1_MDPI: {justifyContent: 'center'},
  outerTextStyle1_LDPI: {justifyContent: 'center'},

  ICICIBankTextStyle_LAPTOP: {display: 'flex'},
  ICICIBankTextStyle_XXXHDPI: {display: 'flex'},
  ICICIBankTextStyle_XXHDPI: {display: 'flex'},
  ICICIBankTextStyle_XHDPI: {display: 'flex'},
  ICICIBankTextStyle_HDPI: {display: 'none'},
  ICICIBankTextStyle_MDPI: {display: 'none'},
  ICICIBankTextStyle_LDPI: {display: 'none'},

  ICICIBankTextStyle1_LAPTOP: {display: 'none'},
  ICICIBankTextStyle1_XXXHDPI: {display: 'none'},
  ICICIBankTextStyle1_XXHDPI: {display: 'none'},
  ICICIBankTextStyle1_XHDPI: {display: 'none'},
  ICICIBankTextStyle1_HDPI: {display: 'flex'},
  ICICIBankTextStyle1_MDPI: {display: 'flex'},
  ICICIBankTextStyle1_LDPI: {display: 'flex'},

  faceBookContainerBtnStyle_LAPTOP: {
    justifyContent: 'flex-end',
    flex: 1
  },
  faceBookContainerBtnStyle_XXXHDPI: {justifyContent: 'flex-end', flex: 1},
  faceBookContainerBtnStyle_XXHDPI: {
    justifyContent: 'flex-end',
    flex: 1,
    marginLeft: responsiveWidth(0),
    marginRight: responsiveWidth(0),
    paddingRight: responsiveWidth(2.5)
  },
  faceBookContainerBtnStyle_XHDPI: {
    // justifyContent: 'center',
    marginLeft: responsiveWidth(0),
    marginRight: responsiveWidth(0),
    paddingRight: responsiveWidth(2.5)
  },
  faceBookContainerBtnStyle_HDPI: {
    // justifyContent: 'center',
    marginLeft: responsiveWidth(0),
    marginRight: responsiveWidth(0),
    paddingRight: responsiveWidth(2.5)
  },
  faceBookContainerBtnStyle_MDPI: {
    // justifyContent: 'center',
    marginLeft: responsiveWidth(0),
    marginRight: responsiveWidth(0),
    paddingRight: responsiveWidth(2.5)
  },
  faceBookContainerBtnStyle_LDPI: {
    // justifyContent: 'center',
    marginLeft: responsiveWidth(0),
    marginRight: responsiveWidth(0),
    paddingRight: responsiveWidth(2.5)
  },

  playStoreContainerBtnStyle_LAPTOP: {justifyContent: 'flex-end', flex: 1},
  playStoreContainerBtnStyle_XXXHDPI: {
    justifyContent: 'flex-end',
    flex: 1
    // marginHorizontal: responsiveWidth(0),
    // paddingHorizontal: responsiveWidth(5)
  },
  playStoreContainerBtnStyle_XXHDPI: {
    justifyContent: 'flex-end',
    flex: 1,
    marginHorizontal: responsiveWidth(0),
    paddingHorizontal: responsiveWidth(2.5)
  },
  playStoreContainerBtnStyle_XHDPI: {
    // justifyContent: 'center',
    marginHorizontal: responsiveWidth(0),
    paddingHorizontal: responsiveWidth(2.5)
  },
  playStoreContainerBtnStyle_HDPI: {
    // justifyContent: 'center',
    marginHorizontal: responsiveWidth(0),
    paddingHorizontal: responsiveWidth(2.5)
  },
  playStoreContainerBtnStyle_MDPI: {
    // justifyContent: 'center',
    marginHorizontal: responsiveWidth(0),
    paddingHorizontal: responsiveWidth(2.5)
  },
  playStoreContainerBtnStyle_LDPI: {
    // justifyContent: 'center',
    marginHorizontal: responsiveWidth(0),
    paddingHorizontal: responsiveWidth(2.5)
  },

  appStoreBtnContainerStyle_LAPTOP: {justifyContent: 'flex-end', flex: 1},
  appStoreBtnContainerStyle_XXXHDPI: {justifyContent: 'flex-end', flex: 1},
  appStoreBtnContainerStyle_XXHDPI: {justifyContent: 'flex-end', flex: 1},
  appStoreBtnContainerStyle_XHDPI: {
    // justifyContent: 'center',
    marginHorizontal: responsiveWidth(0)
  },
  appStoreBtnContainerStyle_HDPI: {
    // justifyContent: 'scenter',
    marginHorizontal: responsiveWidth(0)
  },
  appStoreBtnContainerStyle_MDPI: {
    // justifyContent: 'scenter',
    marginHorizontal: responsiveWidth(0)
  },
  appStoreBtnContainerStyle_LDPI: {
    // justifyContent: 'center',
    marginHorizontal: responsiveWidth(0)
  }
});

let countryId = '';
const getData = async () => {
  countryId = Number(await getPrefData(RESCOUNTRYID));
  const isFirefox = typeof InstallTrigger !== 'undefined';
  storePrefData(FIREFOX_INFO, isFirefox);
  switch (countryId) {
    case COUNTRY_USA:
      country = 'usa';
      break;
    case COUNTRY_CANADA:
      country = 'cannada';
      break;
    case COUNTRY_UAE:
      country = 'uae';
      break;
    case COUNTRY_UK:
      country = 'uk';
      break;
    default:
      country = 'usa';
  }
};

function CustomFooter(props) {
  const {navigation,lastLoginTime} = props;
  getData();
  const buttonOuterViewWidth = `buttonOuterView_${props.measure}`;
  const containerStyleWidth = `containerStyle_${props.measure}`;
  const subBottomContainerWidth = `subBottomContainer_${props.measure}`;
  const subcontainerStyleWidth = `subContainerStyle_${props.measure}`;
  const buttonTextStyle1Width = `buttonTextStyle1_${props.measure}`;
  const outerContainerStyle1Width = `outerContainerStyle1_${props.measure}`;
  const buttonOuterStyle1Width = `buttonOuterStyle1_${props.measure}`;
  const outerTextStyle1Width = `outerTextStyle1_${props.measure}`;
  const faceBookContainerBtnStyleWidth = `faceBookContainerBtnStyle_${props.measure}`;
  const playStoreContainerBtnStyleWidth = `playStoreContainerBtnStyle_${props.measure}`;
  const appStoreBtncontainerStyleWidth = `appStoreBtnContainerStyle_${props.measure}`;
  const ICICIBankTextStyleWidth = `ICICIBankTextStyle_${props.measure}`;
  const usHolidayLink = US_HOLIDAY_LINK;
  const nonUsHolidayLink = NON_US_HOLIDAY_LINK;
  const usTcLink = US_TERMS_AND_CONDTION_LINK;
  const nonusTcLink = NON_US_TERMS_AND_CONDTION_LINK;
  const nonUsDiscLink = NON_US_DISCLAIMER_LINK;
  const countryShortName = Number(countryId) === COUNTRY_USA ? 'usa' : Number(countryId) === COUNTRY_CANADA ? 'canada' : Number(countryId) === COUNTRY_UK ? 'uk' : Number(countryId) === COUNTRY_UAE ? 'uae' : 'usa';
  const contactUsLink = `${HOME_PAGE}${countryShortName}/contact-us`;
  const screenWidth = Dimensions.get('window').width;

  return (
    <View
      ref={customFooterView => {
        this.customFooterView = customFooterView;
      }}>
      {Platform.OS === 'web' ? (
        <View>
          {props.signedIn === false ? (
            <View
              style={{
                flex: 1,
                backgroundColor: '#182340'
              }}>
              <View style={[styles.containerStyle, styles[containerStyleWidth]]}>
                <View style={[styles.subContainerStyle, styles[subcontainerStyleWidth]]}>
                  <View style={{flex: 0.7, flexDirection: 'column'}}>
                    <CustomText style={styles.textStyle}>{M2I}</CustomText>
      
                    <CustomText accessibilityRole="link" href={ICICIBANK_USA + 'remittance_services/money2india/how-it-works.page'} style={styles.textStyleWithOpacity} target="_blank" rel="noopener noreferrer">
                      {HOW_IT_WORKS}
                    </CustomText>
                    {(props.selectedCountry !== 'UAE' && countryShortName === 'usa')? <CustomText accessibilityRole="link" href={'https://nli.icicibank.com/NewRetailWeb/complaint.htm?ITM=nli_cms_ContactUs_Raise_a_Query_hyperlink&amp;_ga=2.61728556.1420898369.1719934635-578951650.1719934635'} style={styles.textStyleWithOpacity} target="_blank" rel="noopener noreferrer">
                      {QUERIES_AND_COMPLAINTS}
                    </CustomText> : null}
                  </View>
                  <View
                    style={{
                      flex: 0.7,
                      marginBottom: screenWidth < 768 ? '8%' : 0
                    }}>
                    <CustomText style={styles.textStyle}>{HELP}</CustomText>

                    <CustomText accessibilityRole="link" href={countryId === COUNTRY_USA ? FAQ_ICCI : NRI_BANKING + 'money_transfer/faq/index.page'} style={styles.textStyleWithOpacity} target="_blank" rel="noopener noreferrer">
                      {FAQ}
                    </CustomText>

                    <CustomText
                      accessibilityRole="link"
                      style={styles.textStyleWithOpacity}
                      target="_blank"
                      rel="noopener noreferrer"
                      href={contactUsLink}>
                      {CONTACT_US}
                    </CustomText>

                    <CustomText accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? usHolidayLink : nonUsHolidayLink} style={styles.textStyleWithOpacity} target="_blank" rel="noopener noreferrer">
                      {LIST_OF_HOLIDAYS}
                    </CustomText>
                  </View>
                  <View
                    style={{
                      flex: 0.7,
                      marginBottom: screenWidth < 768 ? '8%' : 0
                    }}>
                    <CustomText style={styles.textStyle}>{LEGAL}</CustomText>

                    <CustomText accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? usTcLink : nonusTcLink} style={styles.textStyleWithOpacity} target="_blank" rel="noopener noreferrer">
                      {TERMS_AND_CONDITIONS}
                    </CustomText>

                    <CustomText accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? DISCLAIMER_ICCI : nonUsDiscLink} style={styles.textStyleWithOpacity} target="_blank" rel="noopener noreferrer">                      
                      {DISCLAIMER}
                    </CustomText>

                    <CustomText style={styles.textStyleWithOpacity} accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? PRIVACY_POLICY_ICCI : nonusTcLink} target="_blank" rel="noopener noreferrer">
                      {PRIVACY_POLICY}
                    </CustomText>
                  </View>
                  <View
                    style={{
                      flex: 1
                    }}>
                    <CustomText style={styles.textStyle}>{TRANSFER_M2I}</CustomText>

                    <CustomText
                      style={styles.textStyleWithOpacity}
                      onPress={() => {
                        navigation.navigate('CountryLanding');
                      }}>
                      {SEND_M2I_INDIA}
                    </CustomText>

                    <CustomText style={styles.textStyleWithOpacity} accessibilityRole="link" href={NRI_BANKING + 'money_transfer/singapore/transfer-via-m2i.page?'} target="_blank" rel="noopener noreferrer">
                      {SEND_M2I_SING}
                    </CustomText>

                    <CustomText
                      style={styles.textStyleWithOpacity}
                      onPress={() => {
                        navigation.navigate('CountryLanding', {country: 'UAE'});
                      }}>
                      {SEND_M2I_UAE}
                    </CustomText>
                  </View>
                  <View style={[styles.buttonOuterView, styles[buttonOuterViewWidth]]}>
                    <View
                      style={{
                        flex: 1,
                        borderColor: 'rgba(255,255,255,0.5)'
                      }}>
                      <View style={{}}>
                        <CustomText>
                          <CustomText style={{color: 'white', fontSize: 28}}>{TRAVEL_A_LOT}</CustomText>
                          <CustomText
                            style={{
                              color: 'white',
                              fontSize: 28
                            }}>
                            {GET_THE_APP}
                          </CustomText>
                        </CustomText>
                        <View
                          style={{
                            flexDirection: 'row',
                            flex: 1,
                            marginTop: 20
                          }}>
                          <TouchableOpacity
                            style={[styles.buttonStyle, {marginRight: responsiveWidth(1)}]}
                            accessibilityRole="link"
                            href={GOOGLE_PLAY_STORE + 'com.icicibank.m2i'}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <View
                              style={{
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}>
                              <LazyLoadImage alt="googlePlay" src={require('../assets/images/googlePlay.png')} height={27.17} width={25}></LazyLoadImage>
                              <CustomText style={styles.buttonTextStyle}>{GOOGLE_PLAY}</CustomText>
                            </View>
                          </TouchableOpacity>

                          <TouchableOpacity
                            style={[styles.buttonStyle, {marginLeft: responsiveWidth(1)}]}
                            accessibilityRole="link"
                            href={APPLE_STORE + 'icici-bank-money2india/id1524595805'}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <View
                              style={{
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}>
                              <LazyLoadImage alt="appleStore" src={require('../assets/images/appleStore.png')} height={30} width={25}></LazyLoadImage>
                              <CustomText style={styles.buttonTextStyle}>{APP_STORE}</CustomText>
                            </View>
                          </TouchableOpacity>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>

              <View style={[styles.subBottomContainer, styles[subBottomContainerWidth]]}>
                <View
                  style={{
                    flex: 1
                  }}>
                  <View
                    style={{
                      flex: 1,

                      borderColor: 'rgba(255,255,255,0.5)',
                      justifyContent: 'center'
                    }}>
                    <View
                      style={{
                        marginTop: responsiveHeight(6),
                        marginBottom: responsiveHeight(4)
                      }}>
                      <CustomText style={{textAlign: 'center'}}>
                        <CustomText style={{color: 'white', fontSize: 20}}>{TRAVEL_A_LOT}</CustomText>
                        <CustomText
                          style={{
                            fontWeight: 'bold',
                            color: 'white',
                            fontSize: 20
                          }}>
                          {GET_THE_APP}
                        </CustomText>
                      </CustomText>
                      <View
                        style={{
                          flexDirection: 'row',
                          flex: 1,
                          marginTop: responsiveHeight(4),
                          justifyContent: 'center'
                        }}>
                        <TouchableOpacity
                          style={{
                            width: 137.17,
                            height: 50,
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            alignItems: 'center',
                            padding: 10,
                            marginRight: responsiveWidth(2),
                            borderRadius: 5
                          }}
                          accessibilityRole="link"
                          href={GOOGLE_PLAY_STORE + 'com.icicibank.m2i'}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <View
                            style={{
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}>
                            <LazyLoadImage alt="googlePlay" src={require('../assets/images/googlePlay.png')} height={27.17} width={25}></LazyLoadImage>
                            <CustomText style={styles.buttonTextStyle}>{GOOGLE_PLAY}</CustomText>
                          </View>
                        </TouchableOpacity>

                        <TouchableOpacity
                          style={{
                            width: 121.16,
                            height: 50.84,
                            backgroundColor: 'rgba(255,255,255,0.1)',
                            alignItems: 'center',
                            padding: 10,
                            marginLeft: responsiveWidth(0.5),
                            borderRadius: 5
                          }}
                          accessibilityRole="link"
                          href={APPLE_STORE + 'icici-bank-money2india/id1524595805'}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <View
                            style={{
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}>
                            <LazyLoadImage alt="appleStore" src={require('../assets/images/appleStore.png')} height={30} width={25}></LazyLoadImage>
                            <CustomText style={styles.buttonTextStyle}>{APP_STORE}</CustomText>
                          </View>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
              <View
                style={{
                  flexDirection: 'row',
                  width: '100%',
                  justifyContent: 'center'
                }}>
                {/* <CustomText style={styles.textStyle1}>v{global.appVersion}</CustomText> */}
              </View>
            </View>
          ) : (
            <div id="signedInFooter">
              <View
                style={{
                  flex: 1,
                  backgroundColor: '#182340'
                }}>
                <View
                  style={{
                    marginHorizontal: responsiveWidth(2),
                    padding: 15
                  }}>
                  <View style={(styles.outerContainerStyle1, styles[outerContainerStyle1Width])}>
                    <View
                      style={{
                        flexDirection: 'row',
                        flex: 1
                      }}>
                      <View style={[styles.outerTextStyle1, styles[outerTextStyle1Width]]}>
                        <CustomText accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? usTcLink : nonusTcLink} style={styles.textStyle1} target="_blank" rel="noopener noreferrer">
                          {TERMS_AND_CONDITIONS}
                        </CustomText>

                        <CustomText accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? DISCLAIMER_ICCI : nonUsDiscLink} style={styles.textStyle1} target="_blank" rel="noopener noreferrer">
                          {DISCLAIMER}
                        </CustomText>

                        <CustomText accessibilityRole="link" href={Number(countryId) === COUNTRY_USA ? PRIVACY_POLICY_ICCI : nonusTcLink} style={styles.textStyle1} target="_blank" rel="noopener noreferrer">
                          {PRIVACY_POLICY}
                        </CustomText>

                        <CustomText
                          style={[styles.ICICIBankTextStyle, styles[ICICIBankTextStyleWidth]]}
                        >
                          {ICICI_BANK}
                        </CustomText>
                        <CustomText style={styles.textStyle1}>v{global.appVersion}</CustomText>
                        {/* {lastLoginTime &&<CustomText style={styles.textStyle1}>Last Login : {lastLoginTime}</CustomText>} */}
                      </View>
                    </View>

                    <View>
                      <View style={[styles.buttonOuterStyle1, styles[buttonOuterStyle1Width]]}>
                        <View>
                          <TouchableOpacity
                            style={[styles.faceBookContainerBtnStyle, styles[faceBookContainerBtnStyleWidth]]}
                            accessibilityRole="link"
                            href={FACEBOOK_ICICI}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyLoadImage alt="facebook" src={require('../assets/images/facebook.png')} height={30} width={25}></LazyLoadImage>
                            <View>
                              <CustomText style={[styles.buttonTextStyle1, styles[buttonTextStyle1Width]]}>{FOLLOW_US}</CustomText>
                            </View>
                          </TouchableOpacity>
                        </View>
                        <View
                          style={{
                            borderLeftWidth: 1,
                            borderColor: 'white'
                          }}>
                          <TouchableOpacity
                            style={[styles.playStoreContainerBtnStyle, styles[playStoreContainerBtnStyleWidth]]}
                            accessibilityRole="link"
                            href={GOOGLE_PLAY_STORE + 'com.icicibank.m2i'}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <LazyLoadImage alt="googlePlay" src={require('../assets/images/googlePlay.png')} height={20} width={19}></LazyLoadImage>
                            <View>
                              <CustomText style={[styles.buttonTextStyle1, styles[buttonTextStyle1Width]]}>{GOOGLE_PLAY}</CustomText>
                            </View>
                          </TouchableOpacity>
                        </View>
                        <TouchableOpacity
                          style={[styles.appStoreBtnContainerStyle, styles[appStoreBtncontainerStyleWidth]]}
                          accessibilityRole="link"
                          href={APPLE_STORE + 'icici-bank-money2india/id1524595805'}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <LazyLoadImage alt="appleStore" src={require('../assets/images/appleStore.png')} height={20} width={16}></LazyLoadImage>
                          <CustomText style={[styles.buttonTextStyle1, styles[buttonTextStyle1Width]]}>{APP_STORE}</CustomText>
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                </View>

              </View>
          
            </div>
          )}
        </View>
      ) : null}
    </View>
  );
}

export default hocComponent(CustomFooter);
